import { motion } from "framer-motion";

interface ToyFactoryProps {
  active: boolean;
  onComplete: () => void;
}

const ToyFactory = ({ active, onComplete }: ToyFactoryProps) => {
  if (!active) return null;

  return (
    <motion.div
      className="flex flex-col items-center gap-2"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="relative h-40 w-64">
        <motion.div className="absolute inset-0 overflow-hidden rounded-2xl border-2 border-slate-300 bg-gradient-to-b from-slate-100 to-slate-200">
          <div className="absolute left-4 top-2 h-12 w-6 rounded-full bg-slate-400" />
          <div className="absolute right-4 top-2 h-12 w-6 rounded-full bg-slate-400" />

          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="absolute top-4 h-4 w-4 rounded-full"
              style={{ left: `${40 + i * 24}%` }}
              animate={{
                backgroundColor: [
                  "hsl(0 84% 60%)",
                  "hsl(145 72% 44%)",
                  "hsl(40 96% 56%)",
                  "hsl(0 84% 60%)",
                ],
              }}
              transition={{ duration: 1.2, repeat: 3, delay: i * 0.2 }}
            />
          ))}

          <motion.div
            className="absolute bottom-6 left-1/2 -translate-x-1/2 text-4xl"
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: 2, ease: "linear" }}
          >
            ⚙️
          </motion.div>

          <motion.div
            className="absolute inset-0 rounded-2xl bg-blue-500/10"
            animate={{ opacity: [0, 0.3, 0] }}
            transition={{ duration: 0.8, repeat: 4 }}
          />
        </motion.div>

        <motion.div className="absolute -bottom-4 left-0 right-0 h-6 overflow-hidden rounded-full bg-slate-300">
          <motion.div
            className="absolute inset-0 flex gap-2"
            animate={{ x: [0, -20, 0] }}
            transition={{ duration: 0.5, repeat: 6 }}
          >
            {Array.from({ length: 20 }).map((_, i) => (
              <div key={i} className="h-full w-3 rounded bg-slate-400/60" />
            ))}
          </motion.div>
        </motion.div>
      </div>

      <motion.div
        className="text-5xl"
        initial={{ opacity: 0, y: -30, scale: 0 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ delay: 2.5, duration: 0.5, type: "spring" }}
        onAnimationComplete={onComplete}
      >
        🎁
      </motion.div>
    </motion.div>
  );
};

export default ToyFactory;